<template>
  <section id="landing-numbers" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
    <div class="flex desktop">
      <div class="circle-wrapper">
        <vue-ellipse-progress
          :noData="loadData"
          line="butt"
          color="#dd5201"
          emptyColor="#d8d8d8"
          :thickness="35"
          :emptyThickness="35"
          :size="150"
          :progress="100"
          animation="reverse 4000 500">
          <span class="number"><number ref="number1" :from="0" :to="19" :duration="2" /></span>
        </vue-ellipse-progress>
        <p>lat<br>usług dla biznesu</p>
      </div>
      <div class="circle-wrapper">
        <vue-ellipse-progress
          :noData="loadData"
          line="butt"
          color="#dd5201"
          emptyColor="#d8d8d8"
          :thickness="35"
          :emptyThickness="35"
          :size="150"
          :progress="100"
          animation="reverse 4000 500">
          <span class="number"><number ref="number2" :from="0" :to="400" :duration="2" /></span>
        </vue-ellipse-progress>
        <p>MŚP i NGO<br>obsłużonych i zadowolonych</p>
      </div>
      <div class="circle-wrapper">
         <vue-ellipse-progress
          :noData="loadData"
          line="butt"
          color="#dd5201"
          emptyColor="#d8d8d8"
          :thickness="35"
          :emptyThickness="35"
          :size="150"
          :progress="100"
          animation="reverse 4000 500">
          <span class="number"><number ref="number3" :from="0" :to="2" :duration="2" /></span>
        </vue-ellipse-progress>
        <p>mln sztuk<br>zeskanowanej korespondencji</p>
      </div>
      <div class="circle-wrapper">
         <vue-ellipse-progress
          :noData="loadData"
          line="butt"
          color="#dd5201"
          emptyColor="#d8d8d8"
          :thickness="35"
          :emptyThickness="35"
          :size="150"
          :progress="100"
          animation="reverse 4000 500">
          <span class="number"><number ref="number4" :from="0" :to="20" :duration="2" /></span>
        </vue-ellipse-progress>
        <p>tys. godzin<br>wynajmu sal konferencyjnych</p>
      </div>
    </div>
    <div class="flex mobile">
      <div class="circle-wrapper">
        <vue-ellipse-progress
          :noData="loadData"
          line="butt"
          color="#dd5201"
          emptyColor="#d8d8d8"
          :thickness="15"
          :emptyThickness="15"
          :size="70"
          :progress="100"
          animation="reverse 4000 500">
          <span class="number"><number ref="number1" :from="0" :to="19" :duration="2" /></span>
        </vue-ellipse-progress>
        <p>lat<br>usług dla biznesu</p>
      </div>
      <div class="circle-wrapper">
        <vue-ellipse-progress
          :noData="loadData"
          line="butt"
          color="#dd5201"
          emptyColor="#d8d8d8"
          :thickness="15"
          :emptyThickness="15"
          :size="70"
          :progress="100"
          animation="reverse 4000 500">
          <span class="number"><number ref="number2" :from="0" :to="400" :duration="2" /></span>
        </vue-ellipse-progress>
        <p>MŚP i NGO<br>obsłużonych i zadowolonych</p>
      </div>
      <div class="circle-wrapper">
         <vue-ellipse-progress
          :noData="loadData"
          line="butt"
          color="#dd5201"
          emptyColor="#d8d8d8"
          :thickness="15"
          :emptyThickness="15"
          :size="70"
          :progress="100"
          animation="reverse 4000 500">
          <span class="number"><number ref="number3" :from="0" :to="2" :duration="2" /></span>
        </vue-ellipse-progress>
        <p>mln sztuk<br>zeskanowanej korespondencji</p>
      </div>
      <div class="circle-wrapper">
         <vue-ellipse-progress
          :noData="loadData"
          line="butt"
          color="#dd5201"
          emptyColor="#d8d8d8"
          :thickness="15"
          :emptyThickness="15"
          :size="70"
          :progress="100"
          animation="reverse 4000 500">
          <span class="number"><number ref="number4" :from="0" :to="20" :duration="2" /></span>
        </vue-ellipse-progress>
        <p>tys. godzin<br>wynajmu sal konferencyjnych</p>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Landingnumbers',
  data(){
    return{
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
      },
      loadData: true,
    }
  },
  mounted(){
    this.$refs.number1.pause();
    this.$refs.number2.pause();
    this.$refs.number3.pause();
    this.$refs.number4.pause();
  },
  methods: {
    onWaypoint ({ going, direction }) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        // console.log('waypoint going in!');
        this.loadData = false;  
        this.$refs.number1.play();
        this.$refs.number2.play();
        this.$refs.number3.play();
        this.$refs.number4.play();
      }
 
      if (direction === this.$waypointMap.DIRECTION_TOP) {
        // console.log('waypoint going top!')
      }
    },
  }
}
</script>

<style scoped lang="scss">
  section#landing-numbers {  overflow: auto; }
  div.flex { display: flex; flex-wrap: wrap; justify-content: center; }
  div.flex.mobile { display: none; flex-wrap: wrap; justify-content: center; }
  p { margin: 10px 0 0 0; padding: 0; font-size: 16px; text-align: center; color: black; font-weight: 500; }
  
  .circle-wrapper {
    width: 20%;
    margin: 60px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-shrink: 0;

    .number {
      font-size: 30px;
      color: black;
    }
  }

  @media (max-width: 1000px) {
    div.flex.desktop { display: none; }
    div.flex.mobile { display: flex; }
    p { margin: 10px 0 0 0; font-size: 13px; }
    span { font-size: 16px; line-height: 18px; }
    .circle-wrapper { margin: 20px; }
  }

</style>
